/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUsersCog} from '@fortawesome/pro-duotone-svg-icons';

const GroupsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUsersCog} {...props} />
);

export default GroupsIcon;
